// Generated by CoffeeScript 1.9.1
var Collection, FeatureCol, SeqManager, Sequence;
Sequence = require("./Sequence");
FeatureCol = require("./FeatureCol");
Collection = require("backbone-thin").Collection;
module.exports = SeqManager = Collection.extend({
  model: Sequence,
  constructor: function constructor(seqs, g) {
    Collection.apply(this, arguments);
    this.g = g;
    this.on("add reset remove", function (_this) {
      return function () {
        _this.lengthCache = null;
        return _this._bindSeqsWithFeatures();
      };
    }(this), this);
    this.on("reset", function (_this) {
      return function () {
        return _this._autoSetRefSeq();
      };
    }(this));
    this._autoSetRefSeq();
    this.lengthCache = null;
    this.features = {};
    return this;
  },
  getMaxLength: function getMaxLength() {
    if (this.models.length === 0) {
      return 0;
    }
    if (this.lengthCache === null) {
      this.lengthCache = this.max(function (seq) {
        return seq.get("seq").length;
      }).get("seq").length;
    }
    return this.lengthCache;
  },
  prev: function prev(model, endless) {
    var index;
    index = this.indexOf(model) - 1;
    if (index < 0 && endless) {
      index = this.length - 1;
    }
    return this.at(index);
  },
  next: function next(model, endless) {
    var index;
    index = this.indexOf(model) + 1;
    if (index === this.length && endless) {
      index = 0;
    }
    return this.at(index);
  },
  calcHiddenSeqs: function calcHiddenSeqs(n) {
    var i, j, nNew, ref;
    nNew = n;
    for (i = j = 0, ref = nNew; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
      if (this.at(i).get("hidden")) {
        nNew++;
      }
    }
    return nNew - n;
  },
  addFeatures: function addFeatures(features) {
    var colors, obj;
    if (features.config != null) {
      obj = features;
      features = features.seqs;
      if (obj.config.colors != null) {
        colors = obj.config.colors;
        _.each(features, function (seq) {
          return _.each(seq, function (val) {
            if (colors[val.feature] != null) {
              return val.fillColor = colors[val.feature];
            }
          });
        });
      }
    }
    if (_.isEmpty(this.features)) {
      this.features = features;
    } else {
      _.each(features, function (_this) {
        return function (val, key) {
          if (!_this.features.hasOwnProperty(key)) {
            return _this.features[key] = val;
          } else {
            return _this.features[key] = _.union(_this.features[key], val);
          }
        };
      }(this));
    }
    return this._bindSeqsWithFeatures();
  },
  _bindSeqWithFeatures: function _bindSeqWithFeatures(seq) {
    var features;
    features = this.features[seq.attributes.name];
    if (features) {
      seq.set("features", new FeatureCol(features));
      seq.attributes.features.assignRows();
      return seq.set("height", seq.attributes.features.getCurrentHeight() + 1);
    }
  },
  _bindSeqsWithFeatures: function _bindSeqsWithFeatures() {
    return this.each(function (_this) {
      return function (seq) {
        return _this._bindSeqWithFeatures(seq);
      };
    }(this));
  },
  removeAllFeatures: function removeAllFeatures() {
    return delete this.features;
  },
  _autoSetRefSeq: function _autoSetRefSeq() {
    if (this.length > 0) {
      return this.at(0).set("ref", true);
    }
  },
  setRef: function setRef(seq) {
    var obj;
    obj = this.get(seq);
    this.each(function (s) {
      if (seq.cid) {
        if (obj.cid === s.cid) {
          return s.set("ref", true);
        } else {
          return s.set("ref", false);
        }
      }
    });
    this.g.config.set("hasRef", true);
    return this.trigger("change:reference", seq);
  }
});